import usePageContext from '@rover/react-lib/src/context/usePageContext';
import { selectors as frontendEventsSelectors } from '@rover/react-lib/src/redux/ducks/frontendEvents.duck';
import {
  FrontendEventsResultEventsItem,
  useApiFrontendEventsRetrieve,
} from '@rover/rsdk/src/apiClient/latest';
import { Logger } from '@rover/rsdk/src/modules/Logging';
import { DataLayerEvent } from '@rover/types';

import useDucks from './useDucks';

export type FrontendEventsData = {
  /* Use custom DataLayerEvent type because drf-spectacular doesn't support
   * objects with some keys defined (`event`), but others undefined and optional
   */
  frontendEvents?: DataLayerEvent[];
};

// ensures objects in the events array have 'event' keys on them, and refines the type to DataLayerEvent[]
const eventsAreDataLayerEvents = (
  events: DataLayerEvent[] | FrontendEventsResultEventsItem[]
): events is DataLayerEvent[] => events.every((event) => !!event.event);

const selector = (state): FrontendEventsData => ({
  frontendEvents: frontendEventsSelectors.getFrontendEvents(state),
});

const useFrontendEventsShim = (): FrontendEventsData => {
  const { isReactQueryRoute } = usePageContext();
  const { data } = useApiFrontendEventsRetrieve({ query: { enabled: isReactQueryRoute } });
  const { data: selectedData } = useDucks({ selector });
  const frontendEvents = isReactQueryRoute ? data?.events : selectedData.frontendEvents;
  if (!frontendEvents || eventsAreDataLayerEvents(frontendEvents)) {
    return { frontendEvents };
  }
  Logger.error(
    new Error(
      'useFrontendEventsShim received a FrontendEventsResultEventsItem without an event key'
    )
  );
  return { frontendEvents: undefined };
};

export default useFrontendEventsShim;
